// extracted by mini-css-extract-plugin
module.exports = {"splash-icon":"CreateArticleFab_splash-icon__2kmpt"};